import Controller from '@ember/controller';
import { action, get, set } from '@ember/object';
import { service } from '@ember/service';

export default Controller.extend({
  router: service(),

  errorMessage: null,

  reset() {
    set(this, 'errorMessage', null);
  },

  save: action(function (selectedItems) {
    if (get(selectedItems, 'length') === 0) {
      set(
        this,
        'errorMessage',
        'You must select at least one fund for the user',
      );
      return;
    }
    set(this, 'errorMessage', null);
    let selectedFundIds = selectedItems.map((item) => {
      return get(item, 'fund.id');
    });
    set(this, 'model.selectedFundIds', selectedFundIds);
    this.router.transitionTo('admin.users.add.save');
  }),
});
